define('viewmodels/ProductRiskRating/ProductRiskFactorSetup',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'viewmodels/GeneralSettings', 'services/utils'],
    function (ko, router, appsecurity, navigation, app, logger, system, ObjGeneralSettings, utils) {
        var app = require('durandal/app'),
            ko = require('knockout');

        var RiskFactorSetupVM = {
            attached: attached,
            format: format,
            questionResponses: ko.observableArray([]),
            selectedQuestionResponses: ko.observable(),

            //Expandable table
            GetAllAssessmentTypes: GetAllAssessmentTypes,
            AssessmentTypeList: ko.observableArray([]),
            SelectedAssessmentTypeFactor: ko.observable(),

            ActionChanged: ActionChanged,

            SubFactorAssessmentTypeList: ko.observableArray([]),
            SelectedAssessmentTypesForSubFactor: ko.observable(),

            riskLevelsDup: ko.observableArray([]),
            /* Risk Factors List */
            CurrentPageNumber: ko.observable(),
            RiskFactorList: ko.observableArray(),
            SelectedResponseRow: ko.observableArray([]),
            FactorResponsesList: ko.observableArray([]),
            rowExpandClick: rowExpandClick,

            FactorPopUpTitle: ko.observable(),
            FactorPopUpType: ko.observable(),
            openFactorPopup: openFactorPopup,
            closeFactorPopup: closeFactorPopup,
            onDeleteFactor: onDeleteFactor,
            deleteFactor: deleteFactor,
            FactorPopUpType: ko.observable(),
            GetAllInherentLevels: GetAllInherentLevels,
            riskLevels: ko.observableArray([]),
            selectedRiskLevel: ko.observable(),

            parentQuestionChanged: parentQuestionChanged,
            PopulateParentQuestionAndResponseDropdowns: PopulateParentQuestionAndResponseDropdowns,

            /* Languages */
            ObjGeneralSettings: ObjGeneralSettings,
            selectedLanguageFactorType: ko.observableArray([]),
            languageList: ko.observableArray([]),
            //resetRadioButtons: resetRadioButtons,areLanguagesShowsForFactor

            parentFactorList: ko.observableArray(),
            questionTypeChangedFactor: questionTypeChangedFactor,
            selectedResponseTypeFactor: ko.observable(),
            selectedSubFactorResponseTypeFactor: ko.observable(),
            isEditFactorVisible: ko.observable(false),
            isNormalTypeFactorSelected: ko.observable(true),
            isReadOnlyFactorSelected: ko.observable(false),
            isHeaderFactorSelected: ko.observable(false),
            isConditionalFactorSelected: ko.observable(false),
            factorPopupData: ko.observable(),
            saveFactor: saveFactor,
            selectedFactor: ko.observable(new FactorModel({})),

            selectedLanguagesForFactor: ko.observableArray([]),
            factorLanguageList: ko.observableArray(),
            FactorLanguageAdded: FactorLanguageAdded,
            areItemsShownForFactor: ko.observable(true),
            areItemsShownForSubFactor: ko.observable(true),
            loadCurrentLanguagesForFactors: loadCurrentLanguagesForFactors,
            /* End of Factor Modal */

            /* Sub Factors */
            areLanguagesShowsForSubFactor: ko.observable(true),
            editSubFactorPopUp: editSubFactorPopUp,
            selectedSubFactor: ko.observable(new SubFactorModel({})),
            selectedLanguagesForSubFactor: ko.observableArray([]),
            currentSubFactorResponseTypes: ko.observable(),
            subFactorLangageAdded: subFactorLangageAdded,
            addSubFactorClick: addSubFactorClick,
            saveSubFactorClick: saveSubFactorClick,
            subFactorLanguageList: ko.observableArray(),

            ResponsePopUpData: ko.observable(),
            ResponsePopUpTitle: ko.observable(),
            ResponsePopUpType: ko.observable(),

            onDeleteSubFactor: onDeleteSubFactor,
            deleteSubFactor: deleteSubFactor,

            /* Response Types */
            newResponseType: ko.observable(),
            ResponseTypeList: ko.observableArray([]),
            openResponseTypePopUp: openResponseTypePopUp,
            cancelResponseTypePopUp: cancelResponseTypePopUp,
            getAllResponseTypes: getAllResponseTypes,
            addResponseType: addResponseType,
            updateResponseType: updateResponseType,
            deleteResponseType: deleteResponseType,
            getScoreNameByID: getScoreNameByID
        };

        return RiskFactorSetupVM;

        var RiskFactorsTableObj = false;
        var ResponseTableObj = false;

        function attached() {
            GetAllAssessmentTypes();
            getAllResponseTypes();
            getLanguages();
            GetAllInherentLevels();


            RiskFactorsTableObj = $('#riskFactorsTable').DataTable({ "bVisible": false });
            $('#riskFactorsTable').on('page.dt', function (event) {
                checkExpandedRow("", true);
                RiskFactorSetupVM.CurrentPageNumber(RiskFactorsTableObj.page());
            });

            getAllRiskFactors();

        }

        /* Languages Start */
        function getLanguages() {
            RiskFactorSetupVM.ObjGeneralSettings.getLanguages();
            RiskFactorSetupVM.languageList = RiskFactorSetupVM.ObjGeneralSettings.LanguageList();
            if (RiskFactorSetupVM.languageList[0].LANGUAGE_ID._latestValue == 1) {
                RiskFactorSetupVM.languageList.splice(0, 1);
            }
        }

        function getLanguageName(languageId) {
            if (RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length == 0) {
                RiskFactorSetupVM.ObjGeneralSettings.getLanguages();
            }

            for (var i = 0; i < RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length; i++) {
                if (RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID().toString() === languageId) {
                    return RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME();
                }
            }

            return '';
        }
        /* Languages END */

        function GetAllAssessmentTypes() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetAssessmentTypes",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, error) {
                        RiskFactorSetupVM.AssessmentTypeList([]);
                        if (jsonResult != null) {


                            var MappedAssessmentList = $.map(jsonResult, function (result) {
                                return new AssessmentListModel(result);
                            });
                            RiskFactorSetupVM.AssessmentTypeList(MappedAssessmentList);
                        }
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function format(data) {
            try {
                var ResponseHtml =
                    '<div class="child-active" style="margin-left: 3em;">' +
                    '<div class="panel panel-success panel-margin">' +
                    '<div class="panel-heading">' +
                    '<h5 class="panel-title riskFactorCellPanel">Responses';

                ResponseHtml +=
                    '<button id="btnAddResponse" class="btn btn-primary btn-xs pull-right addSubFactorBtn" data-bind="click: $root.addSubFactorClick.bind($data, \'\')" title="Click to Add New Response for the selected Risk Factor">' +
                    '<i class="fa fa-plus"></i> Add Response' +
                    '</button>';

                ResponseHtml +=
                    '</h5>' +
                    '</div>' +
                    '</div>' +
                    '<div class="col-xs-12 subfactor-margin">' +
                    '<table id="factorResponseTable" class="dataTable table-bordered" cellspacing="0">' +
                    '<thead>' +
                    '<tr>' +
                    '<th style="padding: 5px 15px !important;; width: 100px;" class="text-center">Sequential Order Number</th>' +
                    '<th style="display: none">Response ID</th>' +
                    '<th>Response</th>' +
                    '<th>ResponseType</th>' +
                    '<th>Score</th>' +
                    '<th class="actions">Actions</th>' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody data-bind="foreach: FactorResponsesList">' +
                    '<tr>' +
                    '<td class="text-center" data-bind="text: SeqNum"></td>' +
                    '<td style="display: none" data-bind="text: ID"></td>' +
                    '<td data-bind="text: Name"></td>' +
                    '<td data-bind="text: ResponseTypes"></td>' +
                    '<td data-bind="text: $root.getScoreNameByID(Score)"></td>' +
                    '<td class="text-center">' +
                    '<a href="javascript:void(0)" title="Edit Response" class="btn-borderless widget-button" data-bind="click: $root.editSubFactorPopUp">' +
                    '<i class="demo-icon icon-file_edit_special"></i>' +
                    '</a>' +
                    '<a href="javascript:void(0)" title="Delete Response" class="btn-borderless widget-button" data-bind="click: $root.onDeleteSubFactor">' +
                    '<i class="deloitte-icon icon-bin_pos fafonticoncss icon-bar text-danger"></i>' +
                    '</a>' +
                    '</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>';

                return ResponseHtml;
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: Format() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function getScoreNameByID(scoreData) {
            var scoreName = '';
            var scoresArray = scoreData.split('|')

            for (var currIndex = 0; currIndex < scoresArray.length; currIndex++) {
                var score = scoresArray[currIndex];
                var scoreData = score.split(',');
                var riskLevelId = scoreData[0];
                var riskAssessmentId = scoreData[1];
                var isFound = false;

                for (var j = 0; j < RiskFactorSetupVM.riskLevels().length; j++) {
                    var value = RiskFactorSetupVM.riskLevels()[j];
                    if (value.AssessmentTypeId == riskAssessmentId) {
                        scoreName += value.RiskLevelName.split(' ')[0].trim();
                        for (var index = 0; index < value.MappedRiskLevels.length; index++) {
                            var currentRiskLevel = value.MappedRiskLevels[index];

                            if (currentRiskLevel && (typeof currentRiskLevel.RiskLevelId !== 'undefined') && currentRiskLevel.RiskLevelId == riskLevelId) {
                                var data = currentRiskLevel.RiskLevelDescription.split(' -');
                                scoreName += ':' + data[data.length - 1].trim();
                                break;
                            }
                        }

                        isFound = true;
                        break;
                    }
                }

                if (scoresArray.length - 1 > currIndex && isFound) {
                    scoreName += '|';
                }
            }

            return scoreName || scoreData;
        }

        /*  Factors Methods START */

        function openFactorPopup(data) {
            RiskFactorSetupVM.selectedFactor(new FactorModel({}));
            RiskFactorSetupVM.factorLanguageList([]);
            RiskFactorSetupVM.SelectedAssessmentTypeFactor([]);
            RiskFactorSetupVM.selectedLanguagesForFactor([])

            try {
                var newFactorObject = new FactorModel({});

                if (data) {
                    RiskFactorSetupVM.FactorPopUpTitle("Edit Factor");
                    RiskFactorSetupVM.FactorPopUpType("Edit");
                    RiskFactorSetupVM.areItemsShownForFactor(false);
                    RiskFactorSetupVM.isEditFactorVisible(true);
                    RiskFactorSetupVM.subFactorLanguageList([]);
                    newFactorObject = data;
                    RiskFactorSetupVM.selectedFactor(newFactorObject);

                    // Assessment Types 
                    var selectedAssessmentTypeList = newFactorObject.AssessmentTypes().split('|');
                    var Assessment = "";
                    for (var f = 0; f < selectedAssessmentTypeList.length; f++) {
                        for (var k = 0; k < RiskFactorSetupVM.AssessmentTypeList().length; k++) {
                            if (RiskFactorSetupVM.AssessmentTypeList()[k].AssessmentId() == selectedAssessmentTypeList[f]) {
                                if (f == 0)
                                    Assessment += RiskFactorSetupVM.AssessmentTypeList()[k].AssessmentName();
                                else
                                    Assessment += ", " + RiskFactorSetupVM.AssessmentTypeList()[k].AssessmentName();
                            }
                        }
                    }
                    document.getElementById('assessmentTypesForEdit').innerHTML = Assessment;

                    // Response Types
                    var selectedResponseTypeList = newFactorObject.ResponseTypes().split('|');
                    var responseTypes = "";
                    for (var f = 0; f < selectedResponseTypeList.length; f++) {
                        for (var k = 0; k < RiskFactorSetupVM.ResponseTypeList().length; k++) {
                            if (RiskFactorSetupVM.ResponseTypeList()[k].ID == selectedResponseTypeList[f]) {
                                if (f == 0)
                                    responseTypes += RiskFactorSetupVM.ResponseTypeList()[k].Name;
                                else
                                    responseTypes += ", " + RiskFactorSetupVM.ResponseTypeList()[k].Name;
                            }
                        }
                    }
                    document.getElementById('responseTypesForEdit').innerHTML = responseTypes;

                    if (newFactorObject.LanguageData() != null && newFactorObject.LanguageData().length > 0) {
                        loadCurrentLanguagesForFactors(newFactorObject.LanguageData());

                        $.each(newFactorObject.LanguageData(), function (key, value) {
                            $('#factor' + value.LanguageID.toString()).val(value.LanguageData);
                        });
                    }

                } else {
                    RiskFactorSetupVM.FactorPopUpTitle("Add Factor");
                    RiskFactorSetupVM.FactorPopUpType("Add");
                    RiskFactorSetupVM.areItemsShownForFactor(true);

                    RiskFactorSetupVM.selectedFactor(new FactorModel({}));
                    setTimeout(function () {
                        document.getElementById('NormalTypeFactor').checked = true;
                        $('#questionname').focus();
                    }, 200);

                    RiskFactorSetupVM.isEditFactorVisible(false);
                    RiskFactorSetupVM.isNormalTypeFactorSelected(true);
                    RiskFactorSetupVM.isReadOnlyFactorSelected(false);
                    RiskFactorSetupVM.isHeaderFactorSelected(false);
                    RiskFactorSetupVM.isConditionalFactorSelected(false);

                    if (RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length == 0) {
                        RiskFactorSetupVM.ObjGeneralSettings.getLanguages();
                    }

                    RiskFactorSetupVM.languageList = RiskFactorSetupVM.ObjGeneralSettings.LanguageList();
                    if (RiskFactorSetupVM.languageList[0].LANGUAGE_ID._latestValue == 1) {
                        RiskFactorSetupVM.languageList.splice(0, 1);
                    }

                    RiskFactorSetupVM.selectedLanguageFactorType([]);
                    RiskFactorSetupVM.factorPopupData(ko.toJS(newFactorObject));
                    RiskFactorSetupVM.selectedResponseTypeFactor([]);
                    RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor([]);
                    RiskFactorSetupVM.selectedQuestionResponses('');
                }

                $('#factorPopUp').modal('show');
                $("#ParentResponseDropDown").multiselect('refresh');
                $('#FactorRespTypeID').multiselect();
                $('#factorLanguages').multiselect();
                $('#AssessmentTypeMultiselect').multiselect();
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: openAddFactorPopup() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        /**
         *  Save Factor
        **/
        function saveFactor() {
            var newFactor = ko.toJS(RiskFactorSetupVM.selectedFactor());

            if (RiskFactorSetupVM.isNormalTypeFactorSelected()) {
                newFactor.Type = 'Normal';
            }

            if (RiskFactorSetupVM.isReadOnlyFactorSelected()) {
                newFactor.Type = 'ReadOnly';
            }

            if (RiskFactorSetupVM.isHeaderFactorSelected()) {
                newFactor.Type = 'Header';
            }

            if (RiskFactorSetupVM.isConditionalFactorSelected()) {
                newFactor.Type = 'Conditional';
            }


            $('#errorMessageFactor').hide();
            $('#errorMessageFactor').text('');

            // Validation
            if (newFactor.Name === '') {
                $('#errorMessageFactor').show();
                $('#errorMessageFactor').text('Name cannot be empty!');
                return;
            }

            if (!newFactor.ID) {
                if (RiskFactorSetupVM.SelectedAssessmentTypeFactor().length === 0) {
                    $('#errorMessageFactor').show();
                    $('#errorMessageFactor').text('Assesment Types cannot be empty!');
                    return;
                }

                if (RiskFactorSetupVM.isHeaderFactorSelected() === false) {
                    if (RiskFactorSetupVM.selectedResponseTypeFactor().length === 0) {
                        $('#errorMessageFactor').show();
                        $('#errorMessageFactor').text('Response Types cannot be empty!');
                        return;
                    }
                }

                var selectedResponseTypes = "";
                for (var i = 0; i < RiskFactorSetupVM.selectedResponseTypeFactor().length; i++) {
                    if (i == 0)
                        selectedResponseTypes += RiskFactorSetupVM.selectedResponseTypeFactor()[i];
                    else
                        selectedResponseTypes += "|" + RiskFactorSetupVM.selectedResponseTypeFactor()[i];
                }

                newFactor.ResponseTypes = selectedResponseTypes;

                var selectedAssesmentTypes = "";
                for (var i = 0; i < RiskFactorSetupVM.SelectedAssessmentTypeFactor().length; i++) {
                    if (i == 0)
                        selectedAssesmentTypes += RiskFactorSetupVM.SelectedAssessmentTypeFactor()[i];
                    else
                        selectedAssesmentTypes += "|" + RiskFactorSetupVM.SelectedAssessmentTypeFactor()[i];
                }

                newFactor.AssessmentTypes = selectedAssesmentTypes;

                newFactor.ParentQuestionID = $('#ParentQuestionDropDown').val()

                var selectedQR = "";
                for (var i = 0; i < RiskFactorSetupVM.selectedQuestionResponses().length; i++) {
                    if (i == 0)
                        selectedQR += RiskFactorSetupVM.selectedQuestionResponses()[i];
                    else
                        selectedQR += "|" + RiskFactorSetupVM.selectedQuestionResponses()[i];
                }

                newFactor.ParentResponsesID = selectedQR;

                // Languages
                for (var j = 0; j < RiskFactorSetupVM.selectedLanguagesForFactor().length; j++) {
                    for (var i = 0; i < RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length; i++) {
                        if (parseInt(RiskFactorSetupVM.selectedLanguagesForFactor()[j]) == RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                            selectedLanguageId = RiskFactorSetupVM.selectedLanguagesForFactor()[j];
                            factorLanguageData = new FactorLanguageData(selectedLanguageId);

                            if (factorLanguageData.LanguageData == "") {
                                $('#errorMessageFactor').show();
                                $('#errorMessageFactor').text('Response in ' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ' cannot be empty!');
                                return;
                            } else {
                                $('#errorMessageFactor').text('');
                            }

                            RiskFactorSetupVM.factorLanguageList.push(factorLanguageData);
                        }
                    }
                }

                newFactor.LanguageData = ko.toJS(RiskFactorSetupVM.factorLanguageList());
            } else {

                if (RiskFactorSetupVM.isConditionalFactorSelected() === true) {
                    if (RiskFactorSetupVM.selectedQuestionResponses().length === 0) {
                        $('#errorMessageFactor').show();
                        $('#errorMessageFactor').text('You have to select at least one Parent Response!');
                        return;
                    }
                }

                for (var i = 0; i < newFactor.LanguageData.length; i++) {
                    var currentLanguage = newFactor.LanguageData[i];
                    currentLanguage.LanguageData = $('#factor' + currentLanguage.LanguageID.toString()).val();
                }
            }

            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = $("input[name='__RequestVerificationToken']").val();
            try {
                $.ajax({
                    url: "/api/productRiskFactors",
                    data: newFactor,
                    type: newFactor.ID ? "PUT" : "POST",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

                function ajaxSuccess(jsonResult, success) {
                    getAllRiskFactors();
                    RiskFactorSetupVM.selectedFactor(new FactorModel({}))
                    $('#factorPopUp').modal('hide');
                }

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in deleteProduct() method in ProductConfiguration.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in addProduct() method in ProductConfiguration.js';
                        logger.logMessage(msg);
                    }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addProduct() method in ProductConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function questionTypeChangedFactor(data, event) {
            try {
                RiskFactorSetupVM.isNormalTypeFactorSelected(true);
                RiskFactorSetupVM.isReadOnlyFactorSelected(false);
                RiskFactorSetupVM.isHeaderFactorSelected(false);
                RiskFactorSetupVM.isConditionalFactorSelected(false);
                document.getElementById("ReadOnlyTypeFactor").checked = false;
                document.getElementById("HeaderTypeFactor").checked = false;
                document.getElementById("ConditionalTypeFactor").checked = false;
                document.getElementById(event.currentTarget.id).checked = true;
                $('#FactorRespTypeID').multiselect();

                if (event.currentTarget.value == "NormalTypeFactor") {
                    RiskFactorSetupVM.isNormalFactorSelected(true);
                } else if (event.currentTarget.value == "ReadOnlyTypeFactor") {
                    RiskFactorSetupVM.isReadOnlyFactorSelected(true);
                } else if (event.currentTarget.value == "HeaderTypeFactor") {
                    RiskFactorSetupVM.isHeaderFactorSelected(true);
                } else if (event.currentTarget.value == "ConditionalTypeFactor") {
                    RiskFactorSetupVM.isConditionalFactorSelected(true);
                    PopulateParentQuestionAndResponseDropdowns();

                    $("#factorsFormScroll").css({ "height": "37rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                    $("#ParentResponseDropDown").multiselect();
                }

                return true;
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QuestionTypeChangedFactor() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function populateParentFactorsDropdowns() {
            try {
                if (RiskFactorSetupVM.parentFactorList().length == 0) {
                    getAllRiskFactors();
                }

                $("#ParentQuestionLabel").html($("#ParentQuestionDropDown :selected").text());

                if ($('#ParentQuestionDropDown').text() != "" && $('#ParentQuestionDropDown').text() != undefined) {
                    ParentQuestionChanged();
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: populateParentFactorsDropdowns() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function closeFactorPopup() {
            if (RiskFactorSetupVM.FactorPopUpType() == 'Add Factor') {
                RiskFactorSetupVM.currentlySelectedResponses([]);
            }
        }


        function FactorLanguageAdded() {
            try {
                var selectedLanguage = RiskFactorSetupVM.selectedLanguagesForFactor();
                $('#DynamicRiskFactorDiv').empty();

                var additionalLanguagesHTML = "";
                for (var j = 0; j < selectedLanguage.length; j++) {
                    for (var i = 0; i < RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length; i++) {
                        if (parseInt(selectedLanguage[j]) == RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                            additionalLanguagesHTML +=
                                '<div class="form-group">' +
                                '<label class="col-xs-4 control-label">Risk Factor (' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                                '<div class="col-xs-6">' +
                                '<input id="factor' + selectedLanguage[j] + '" class="form-control" placeholder="Risk Factor in ' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value: factorLanguageList().LanguageData" type="text" />' +
                                '</div>' +
                                '</div>';
                        }
                    }
                }

                document.getElementById('DynamicRiskFactorDiv').innerHTML = additionalLanguagesHTML;
                ko.cleanNode(document.getElementById('DynamicRiskFactorDiv'));
                ko.applyBindings(RiskFactorSetupVM, document.getElementById("DynamicRiskFactorDiv"));

                if (additionalLanguagesHTML != "") {
                    $("#subFactorResponseFormScroll").css({ "height": "auto", "max-height": "300px", "overflow-y": "scroll", "overflow-x": "hidden" });
                    $("#subFactorModalContent").css({ "height": "auto", "max-height": "450px" });
                } else {
                    $('#subFactorResponseFormScroll').removeAttr("style");
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: subFactorLangageAdded() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function loadCurrentLanguagesForFactors(languagesList) {
            try {
                $('#DynamicRiskFactorDiv').empty();
                var languagesInputs = "";

                $.each(languagesList, function (key, value) {
                    languagesInputs +=
                        '<div class="form-group">' +
                        '<label class="col-xs-4 control-label">Factor (' + getLanguageName(value.LanguageID) + ')</label>' +
                        '<div class="col-xs-6">' +
                        '<input id="factor' + value.LanguageID + '" class="form-control" placeholder="Factor in ' + getLanguageName(value.LanguageID) + '" data-bind="value: factorLanguageList().LanguageData" type="text" />' +
                        '</div>' +
                        '</div>';
                });

                document.getElementById('DynamicRiskFactorDiv').innerHTML = languagesInputs;
                ko.cleanNode(document.getElementById('DynamicRiskFactorDiv'));
                ko.applyBindings(RiskFactorSetupVM, document.getElementById("DynamicRiskFactorDiv"));

                if (languagesList.length > 2) {
                    $("#factorsFormScroll").css({ "height": "35rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                    $("#factorsFormScroll").css({ "height": "auto", "max-height": "450px" });
                } else {
                    $('#factorsFormScroll').removeAttr("style");
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: loadCurrentLanguagesForSubFactors() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        /**
         * Open Delete Factor Confirmation PopUP
         **/
        function onDeleteFactor(data, event) {
            try {
                app.showMessage('<b>Are you sure that you want to delete this Factor?<br/><br/><b>', 'Delete Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                    .then(function (option) {
                        if (option === 'Confirm') {
                            deleteFactor(data);
                        }
                    });

                setTimeout(function () {
                    $(event.target).focus();
                }, 1);
                event.preventDefault();
                event.stopImmediatePropagation();
                event.stopPropagation();
                return false;
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: deleteResponseType() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        /**
         *  Delete Factor
        **/
        function deleteFactor(data) {
            try {
                $.ajax({
                    url: "/api/productRiskFactors/" + data.ID,
                    type: "DELETE",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in deleteFactor() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(result, status) {
                try {
                    getAllRiskFactors();
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteFactor() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {
                                    navigation.unauthorized();
                                }
                            });
                    } else if (error.status == 409) {
                        logger.logError('You are not able to delete this Factor, because it is used somewhere in the application!', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in deleteFactor() method in RiskFactorSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteFactor() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function parentQuestionChanged() {
            try {
                //RiskFactorSetupVM.FactorResponsesList([])
                $("#ParentQuestionLabel").html($("#ParentQuestionDropDown :selected").text());

                var value = $('#ParentQuestionDropDown').val();

                if (value) {
                    // For Parent Response Dropdown
                    getFactorsResponses(value).then(function () {
                        if (RiskFactorSetupVM.questionResponses().length == 0) {
                            $('#errMessageForQR-wrapper').show();
                            $('#ParentResponseDropDown-wrapper').hide();
                            $('#errMessageForQR').text('This Question does not has responses!');
                        }
                        else {
                            $('#errMessageForQR-wrapper').hide();
                            $('#ParentResponseDropDown-wrapper').show();
                            $('#errMessageForQR').text('');
                        }
                    });;
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ParentQuestionChanged() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function PopulateParentQuestionAndResponseDropdowns() {
            try {
                if (RiskFactorSetupVM.RiskFactorList().length == 0) {
                    getAllRiskFactors();
                }
                $("#ParentQuestionLabel").html($("#ParentQuestionDropDown :selected").text());

                if ($('#ParentQuestionDropDown').text() != "" && $('#ParentQuestionDropDown').text() != undefined) {
                    RiskFactorSetupVM.questionResponses([])
                    parentQuestionChanged();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PopulateParentQuestionAndResponseDropdowns() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }


        /**
         *  GET Factors
        **/
        function getAllRiskFactors() {
            try {
                $.ajax({
                    url: "/api/productRiskFactors",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getAllRiskFactors() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }


            function ajaxSuccess(jsonResult, error) {
                try {
                    $("#riskFactorsTable tbody tr").remove();
                    $('#loadingImgMainFactors').hide();
                    $('#riskFactorsContent').show();

                    if (jsonResult && jsonResult.length > 0) {
                        if (RiskFactorSetupVM.RiskFactorList().length > 0) {
                            checkExpandedRow("", true);
                        }
                        RiskFactorSetupVM.RiskFactorList([]);

                        //TODO selected + sub

                        RiskFactorsTableObj.clear().destroy();
                        $('#riskFactorsTable tbody tr').remove();


                        var factorList = $.map(jsonResult, function (result) {
                            return new FactorModel(result);
                        });

                        RiskFactorSetupVM.RiskFactorList(factorList);


                        RiskFactorsTableObj = undefined;
                        RiskFactorsTableObj = $('#riskFactorsTable').DataTable({
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bSortable": false,
                                "bVisible": true
                            }, {
                                "aTargets": [1],
                                "bVisible": false,
                                "bSortable": false
                            }, {
                                "aTargets": [2],
                                "bVisible": true,
                            }, {
                                "aTargets": [3],
                                "bSortable": true,
                            }, {
                                "aTargets": [4],
                                "bSortable": false,
                                "sClass": "text-center",
                                "bVisible": true
                            }]
                        });

                        $('#riskFactorsTable').DataTable().draw(false);
                        RiskFactorSetupVM.CurrentPageNumber(RiskFactorsTableObj.page());
                    } else if (jsonResult.length == 0) {
                        checkExpandedRow("", true);
                        RiskFactorsTableObj.destroy();
                        $('#riskFactorsTable tbody tr').remove();
                        RiskFactorSetupVM.RiskFactorList([]);

                        RiskFactorsTableObj = $('#riskFactorsTable').DataTable({
                            "bresponsive": true,
                            "aocolumndefs": [{
                                "atargets": [0],
                                "bsortable": false,
                                "sclass": "details-control action-bgcolor"
                            },
                            {
                                "atargets": [1],
                                "bvisible": false
                            },
                            {
                                "atargets": [5],
                                "sclass": "text-center",
                                "bsortable": false,
                                "bvisible": true
                            }]
                        });

                        $('#riskFactorsTable').DataTable().draw(false);
                    } else {
                        logger.logError('An error occurred while fetching Risk Factors.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getAllRiskFactors() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {
                                    navigation.unauthorized();
                                }
                            });
                    } else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllRiskFactors() method in RiskFactorSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllRiskFactors() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            };
        }

        function checkExpandedRow(row, isPaginating) {
            try {
                var currentRowIndex;
                var rowsInTable = $('#riskFactorsTable').find('tr');
                if (isPaginating) {
                    currentRowIndex = -1;
                } else {
                    currentRowIndex = row.index();
                }

                var info = RiskFactorsTableObj.page.info();
                for (var i = 1, j = rowsInTable.length; i < j; i++) {
                    var tr = $('#riskFactorsTable').find('tr').get(i);
                    if (RiskFactorsTableObj.row(tr).index() != currentRowIndex) {
                        var tableRowIndex = 0;
                        if (isPaginating) {
                            tableRowIndex = (RiskFactorSetup.CurrentPageNumber() * info.length) + (i - 1);
                        } else {
                            tableRowIndex = (info.page * info.length) + (i - 1);
                        }

                        if ((RiskFactorsTableObj.row(tableRowIndex).child() != undefined)
                            && (RiskFactorsTableObj.row(tableRowIndex).child.isShown())) {
                            RiskFactorsTableObj.row(tableRowIndex).child.remove();
                            tr.removeAttribute('class', 'shown');
                            j = $('#riskFactorsTable').find('tr').length;
                        }
                    }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function rowExpandClick(data, event) {
            try {
                var tr = $(event.currentTarget).closest('tr');
                var row = RiskFactorsTableObj.row(tr);

                RiskFactorSetupVM.SelectedResponseRow([]);
                RiskFactorSetupVM.SelectedResponseRow.push(tr);
                RiskFactorSetupVM.SelectedResponseRow.push(data);
                checkExpandedRow(row, false);

                if (row.child.isShown()) {
                    row.child.hide();
                    tr.removeClass('shown');
                    ResponseTableObj = false;
                } else {
                    getFactorsResponses(data).then(function () {
                        createResponsesTable(RiskFactorSetupVM.SelectedResponseRow());

                    });
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: rowExpandClick() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function createResponsesTable(param) {
            var tr = param[0];
            var row = RiskFactorsTableObj.row(tr);
            row.child("");
            row.child(format(row.data())).show();
            tr.addClass('shown');

            ko.applyBindingsToNode($('#factorResponseTable tbody').get(0), {
                foreach: RiskFactorSetupVM.FactorResponsesList()
            }, RiskFactorSetupVM);

            ko.applyBindingsToNode($('#btnAddResponse').get(0), {
                click: RiskFactorSetupVM.addSubFactorClick
            }, param[1]);

            ResponseTableObj = $('#factorResponseTable').DataTable({
                "bResponsive": true,
                "bPaginate": true,
                "aaSorting": [[0, "asc"]],
                "aoColumnDefs": [{
                    "aTargets": [0],
                    "bSortable": true
                }, {
                    "aTargets": [1],
                    "bVisible": false
                }, {
                    "aTargets": [2],
                    "bSortable": true
                }, {
                    "aTargets": [5],
                    "bSortable": false,
                    "sClass": "text-center",
                    "bVisible": true
                }]
            });
        }
        /* Factors Methods END */

        /* SubFactors Methods Start */

        function getFactorsResponses(data) {
            if (data) {
                if (typeof data == 'object') {
                    var parentFactorID = ko.toJS(data.ID);
                } else {
                    var parentFactorID = ko.toJS(data);
                }
            }
            try {
                return $.ajax({
                    url: "/api/productRiskFactors/subFactors/" + parentFactorID,
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getFactorsResponses() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (data && typeof data == 'object') {
                        RiskFactorSetupVM.FactorResponsesList([]);

                        if (jsonResult != null && jsonResult.length > 0) {
                            RiskFactorSetupVM.FactorResponsesList(jsonResult);
                        } else if (jsonResult == null) {
                            logger.logError('An error occurred while fetching the responses for this question.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        }
                    } else {
                        RiskFactorSetupVM.questionResponses([])

                        if (jsonResult != null && jsonResult.length > 0) {
                            RiskFactorSetupVM.questionResponses(jsonResult);
                            $("#ParentResponseDropDown").multiselect('refresh');
                        } else if (jsonResult == null) {
                            logger.logError('An error occurred while fetching the responses for this question.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        }

                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getFactorsResponses() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {
                                    navigation.unauthorized();
                                }
                            });
                    } else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getFactorsResponses() method in RiskFactorSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getFactorsResponses() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            };
        }

        function addSubFactorClick(data, event) {
            try {
                RiskFactorSetupVM.currentSubFactorResponseTypes([]);
                RiskFactorSetupVM.selectedResponseTypeFactor([]);
                RiskFactorSetupVM.selectedSubFactorResponseTypeFactor([]);
                RiskFactorSetupVM.subFactorLanguageList([]);
                RiskFactorSetupVM.areItemsShownForFactor(true);

                var parent = ko.toJS(data);
                RiskFactorSetupVM.selectedSubFactor(new SubFactorModel({
                    ParentFactorID: parent.ID,
                    ResponseTypes: parent.ResponseTypes
                }));

                // Return all Selected Parent Response Types
                var parentResponseTypeIds = parent.ResponseTypes.split('|');

                var mappedResponseTypeList = $.map(RiskFactorSetupVM.ResponseTypeList(), function (responseType) {
                    for (var i = 0; i < parentResponseTypeIds.length; i++) {
                        if (parentResponseTypeIds[i] == parseInt(responseType.ID)) {
                            return responseType;
                        }
                    }
                });
                RiskFactorSetupVM.currentSubFactorResponseTypes(mappedResponseTypeList);

                //Return all Selected Parent Assessment Types
                var parentAssessmentTypeIds = parent.AssessmentTypes.split('|');

                var mappedAssessmentTypeList = $.map(RiskFactorSetupVM.AssessmentTypeList(), function (assessmentType) {
                    for (var i = 0; i < parentAssessmentTypeIds.length; i++) {
                        if (parentAssessmentTypeIds[i] == ko.toJS(assessmentType).AssessmentId) {
                            return assessmentType;
                        }
                    }
                });

                RiskFactorSetupVM.SubFactorAssessmentTypeList(mappedAssessmentTypeList);

                // Languages
                RiskFactorSetupVM.areLanguagesShowsForSubFactor(true);
                if (RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length == 0) {
                    RiskFactorSetupVM.ObjGeneralSettings.getLanguages();
                }

                RiskFactorSetupVM.languageList = RiskFactorSetupVM.ObjGeneralSettings.LanguageList();
                if (RiskFactorSetupVM.languageList[0].LANGUAGE_ID._latestValue == 1) {
                    RiskFactorSetupVM.languageList.splice(0, 1);
                }

                RiskFactorSetupVM.selectedLanguagesForSubFactor([]);
                RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor([]);

                RiskFactorSetupVM.ResponsePopUpTitle("Add Response");
                RiskFactorSetupVM.ResponsePopUpType("Add");

                $('#subFactorResponsePopup').modal('show');
                $('#subFactorResponseTypeSelect').multiselect();
                $('#subFactorLanguages').multiselect();
                $('#assTypesSubFactorMultiselect').multiselect();
                setTimeout("$('#sequentialNumberInput').focus();", 200);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AddResponsePopUp() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function editSubFactorPopUp(data, event) {
            try {
                RiskFactorSetupVM.ResponsePopUpTitle("Edit Response");
                RiskFactorSetupVM.ResponsePopUpType("Edit");
                RiskFactorSetupVM.areLanguagesShowsForSubFactor(false);
                RiskFactorSetupVM.areItemsShownForFactor(false);
                RiskFactorSetupVM.subFactorLanguageList([]);
                var newSubFactor = new SubFactorModel(data);
                RiskFactorSetupVM.selectedSubFactor(newSubFactor);

                // Assessment Types 
                var selectedAssessmentTypeList = newSubFactor.AssessmentTypes().split('|');
                var Assessment = "";
                for (var f = 0; f < selectedAssessmentTypeList.length; f++) {
                    for (var k = 0; k < RiskFactorSetupVM.AssessmentTypeList().length; k++) {
                        if (RiskFactorSetupVM.AssessmentTypeList()[k].AssessmentId() == selectedAssessmentTypeList[f]) {
                            if (f == 0)
                                Assessment += RiskFactorSetupVM.AssessmentTypeList()[k].AssessmentName();
                            else
                                Assessment += ", " + RiskFactorSetupVM.AssessmentTypeList()[k].AssessmentName();
                        }
                    }
                }
                document.getElementById('assessmentTypesForEditForSubFactors').innerHTML = Assessment;

                // Response Types  selectedSubFactorResponseTypeFactor    
                document.getElementById('responseTypesForEditForSubFactors').innerHTML = newSubFactor.ResponseTypes();

                //Languages
                if (newSubFactor.LanguageData() != null && newSubFactor.LanguageData().length > 0) {
                    loadCurrentLanguagesForSubFactors(newSubFactor.LanguageData());

                    $.each(newSubFactor.LanguageData(), function (key, value) {
                        $('#response' + value.LanguageID.toString()).val(value.LanguageData);
                    });
                }


                BindDynamicHtmlForDropDownsEdit(data.Score.split('|'));


                $('#subFactorResponsePopup').modal('show');
                $('#subFactorResponseTypeSelect').multiselect();
                $('#subFactorLanguages').hide();
                setTimeout("$('#sequentialNumberInput').focus();", 200);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: editSubFactorPopUp() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function saveSubFactorClick(data, event) {
            try {
                $('#errorMessageSubFactor').hide();
                $('#errorMessageSubFactor').text('');

                var subFactorData = ko.toJS(data);

                if (subFactorData.SeqNum === '') {
                    $('#errorMessageSubFactor').show();
                    $('#errorMessageSubFactor').text('Sequential Order Number can not be empty!');
                    return;
                }

                if (parseInt(subFactorData.SeqNum) < 1) {
                    $('#errorMessageSubFactor').show();
                    $('#errorMessageSubFactor').text('Sequential Order Number can not be less than 1!');
                    return;
                }

                if (subFactorData.Name == '') {
                    $('#errorMessageSubFactor').show();
                    $('#errorMessageSubFactor').text('Sub Factor name can not be empty!');
                    return;
                }

                if (RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor().length === 0) {
                    $('#errorMessageSubFactor').show();
                    $('#errorMessageSubFactor').text('Assesment Types cannot be empty!');
                    return;
                }

                if (RiskFactorSetupVM.selectedSubFactorResponseTypeFactor().length === 0) {
                    $('#errorMessageSubFactor').show();
                    $('#errorMessageSubFactor').text('Response Types cannot be empty!');
                    return;
                }

                if (subFactorData.ID) {
                    for (var i = 0; i < subFactorData.LanguageData.length; i++) {
                        currentLanguage = subFactorData.LanguageData[i];
                        currentLanguage.LanguageData = $('#response' + currentLanguage.LanguageID.toString()).val();
                    }
                    var RiskMapping = "";

                    for (var i = 0; i < subFactorData.Score.split('|').length; i++) {
                        for (var j = 0; j < RiskFactorSetupVM.AssessmentTypeList().length; j++) {
                            if (RiskFactorSetupVM.AssessmentTypeList()[j].AssessmentId() == subFactorData.Score.split('|')[i].split(',')[1]) {

                                if (i == 0) {
                                    RiskMapping += $('#' + subFactorData.Score.split('|')[i].split(',')[1]).val() + ',' + subFactorData.Score.split('|')[i].split(',')[1]
                                } else {
                                    RiskMapping += "|" + $('#' + subFactorData.Score.split('|')[i].split(',')[1]).val() + ',' + subFactorData.Score.split('|')[i].split(',')[1];
                                }
                            }
                        }
                    }

                    subFactorData.Score = RiskMapping;
                    sendSubFactorRequest(subFactorData);
                } else {
                    // Response Types
                    var selectedResponseTypes = "";
                    for (var i = 0; i < RiskFactorSetupVM.selectedSubFactorResponseTypeFactor().length; i++) {
                        if (i == 0)
                            selectedResponseTypes += RiskFactorSetupVM.selectedSubFactorResponseTypeFactor()[i];
                        else
                            selectedResponseTypes += "|" + RiskFactorSetupVM.selectedSubFactorResponseTypeFactor()[i];
                    }
                    subFactorData.ResponseTypes = selectedResponseTypes;

                    // Assessment Types
                    var selectedAssessmentTypes = "";
                    for (var i = 0; i < RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor().length; i++) {
                        if (i == 0)
                            selectedAssessmentTypes += RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[i];
                        else
                            selectedAssessmentTypes += "|" + RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[i];
                    }
                    subFactorData.AssessmentTypes = selectedAssessmentTypes;

                    // Ass Types with ,
                    var selectedAssessmentId = "";
                    for (var i = 0; i < RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor().length; i++) {
                        if (i == 0)
                            selectedAssessmentId += $('#' + RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[i]).val() + ',' + RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[i];
                        else
                            selectedAssessmentId += "|" + $('#' + RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[i]).val() + ',' + RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[i];
                    }
                    subFactorData.Score = selectedAssessmentId;

                    //Languages
                    for (var j = 0; j < RiskFactorSetupVM.selectedLanguagesForSubFactor().length; j++) {
                        for (var i = 0; i < RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length; i++) {
                            if (parseInt(RiskFactorSetupVM.selectedLanguagesForSubFactor()[j]) == RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                                selectedLanguageId = RiskFactorSetupVM.selectedLanguagesForSubFactor()[j];
                                subFactorLanguageData = new SubFactorLanguageData(selectedLanguageId);

                                if (subFactorLanguageData.LanguageData == "") {
                                    $('#errorMessageSubFactor').show();
                                    $('#errorMessageSubFactor').text('Response in ' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ' cannot be empty!');
                                    return;
                                } else {
                                    $('#errorMessageSubFactor').text('');
                                }

                                RiskFactorSetupVM.subFactorLanguageList.push(subFactorLanguageData);
                            }
                        }
                    }

                    subFactorData.LanguageData = ko.toJS(RiskFactorSetupVM.subFactorLanguageList);
                    sendSubFactorRequest(subFactorData);
                }

                if ($('#errorMessageSubFactor').text() == "") {
                    $('#subFactorResponsePopup').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: saveSubFactorClick() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function sendSubFactorRequest(data) {
            try {
                if ($('#errorMessageSubFactor').text() == "") {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;

                    $.ajax({
                        url: "/api/productRiskFactors/subFactors",
                        headers: headers,
                        type: data.ID ? "PUT" : "POST",
                        applicationType: 'application/json',
                        dataType: 'json',
                        data: data
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in updateSubFactor() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    getFactorsResponses({ ID: data.ParentFactorID }).then(function () {
                        createResponsesTable(RiskFactorSetupVM.SelectedResponseRow());
                    });
                    toastr.success("Sub Factor has been added successfully!");

                    if (jsonResult == 1) {
                        logger.logSuccess('SubFactor updated successfully .', 'Success', system.getModuleId(RiskFactorSetupVM), true);
                    } else if (jsonResult == 2) {
                        logger.logError('The SubFactor that you are trying to update does not exist. Please refresh the page and try again.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    } else {
                        logger.logError('An error occurred while updating the SubFactor. Please contact the Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in updateSubFactor() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    getFactorsResponses({ ID: data.ParentFactorID }).then(function () {
                        createResponsesTable(RiskFactorSetupVM.SelectedResponseRow());
                    });


                    if (error.status == 409) {
                        app.showMessage("You are not able to create Response with equal Response Type and Name!", "Error in Create Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {
                                    navigation.unauthorized();
                                }
                            });
                    }

                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {
                                    navigation.unauthorized();
                                }
                            });
                    } else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in updateSubFactor() method in RiskFactorSetup.js';
                        logger.logMessage(msg);
                    }
                    toastr.success("Sub Factor has been added successfully!");
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in updateSubFactor() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function loadCurrentLanguagesForSubFactors(languagesList) {
            try {
                $('#DynamicResponseDiv').empty();
                var languagesInputs = "";

                $.each(languagesList, function (key, value) {
                    languagesInputs +=
                        '<div class="form-group">' +
                        '<label class="col-xs-4 control-label">Response (' + getLanguageName(value.LanguageID) + ')</label>' +
                        '<div class="col-xs-6">' +
                        '<input id="response' + value.LanguageID + '" class="form-control" placeholder="Response in ' + getLanguageName(value.LanguageID) + '" data-bind="value: subFactorLanguageList().LanguageData" type="text" />' +
                        '</div>' +
                        '</div>';
                });

                document.getElementById('DynamicResponseDiv').innerHTML = languagesInputs;
                ko.cleanNode(document.getElementById('DynamicResponseDiv'));
                ko.applyBindings(AMLQsViewModel, document.getElementById("DynamicResponseDiv"));

                if (item.length > 2) {
                    $("#subFactorResponseFormScroll").css({ "height": "35rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                    $("#subFactorModalContent").css({ "height": "auto", "max-height": "450px" });
                } else {
                    $('#subFactorResponseFormScroll').removeAttr("style");
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: loadCurrentLanguagesForSubFactors() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function subFactorLangageAdded() {
            try {
                var selectedLanguage = RiskFactorSetupVM.selectedLanguagesForSubFactor();
                $('#DynamicResponseDiv').empty();

                var additionalLanguagesHTML = "";
                for (var j = 0; j < selectedLanguage.length; j++) {
                    for (var i = 0; i < RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length; i++) {
                        if (parseInt(selectedLanguage[j]) == RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                            additionalLanguagesHTML +=
                                '<div class="form-group">' +
                                '<label class="col-xs-4 control-label">Response (' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                                '<div class="col-xs-6">' +
                                '<input id="response' + selectedLanguage[j] + '" class="form-control" placeholder="Response in ' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value: subFactorLanguageList().LanguageData" type="text" />' +
                                '</div>' +
                                '</div>';
                        }
                    }
                }

                document.getElementById('DynamicResponseDiv').innerHTML = additionalLanguagesHTML;
                ko.cleanNode(document.getElementById('DynamicResponseDiv'));
                ko.applyBindings(RiskFactorSetupVM, document.getElementById("DynamicResponseDiv"));

                if (additionalLanguagesHTML != "") {
                    $("#subFactorResponseFormScroll").css({ "height": "auto", "max-height": "300px", "overflow-y": "scroll", "overflow-x": "hidden" });
                    $("#subFactorModalContent").css({ "height": "auto", "max-height": "450px" });
                } else {
                    $('#subFactorResponseFormScroll').removeAttr("style");
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: subFactorLangageAdded() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function GetAllInherentLevels() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetAllInherentLevelswithNA",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { AssessmentId: 0 }
                })
                    .success(function (jsonResult, Error) {
                        var mappedIRSData = $.map(jsonResult, function (result) {
                            return new RiskLevelModel(result);
                        });
                        RiskFactorSetupVM.riskLevels(mappedIRSData);

                        var mappedIRSDataDup = $.map(jsonResult, function (result) {
                            return new RiskLevelModel(result);
                        });
                        RiskFactorSetupVM.riskLevelsDup(mappedIRSDataDup);
                    })
                    .fail(function (jsonResult, log) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllInherentLevels() method in QualitativeSetup.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllInherentLevels() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ActionChanged() {
            BindDynamicHtmlForDropDowns();
        }

        function BindDynamicHtmlForDropDowns() {
            try {
                var selectedassessments = RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor();
                $('#DynamicScoreDiv').empty();
                var DynamicHTMl = "";
                for (var j = 0; j < RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor().length; j++) {
                    for (var i = 0; i < RiskFactorSetupVM.AssessmentTypeList().length; i++) {
                        if (RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[j] == RiskFactorSetupVM.AssessmentTypeList()[i].AssessmentId()) {

                            DynamicHTMl +=
                                '<div class="form-group" id="appSubfactor">' +
                                '<label class="col-xs-4 control-label">' + RiskFactorSetupVM.AssessmentTypeList()[i].AssessmentName() + ' Risk Score :</label>' +
                                '<div class="col-xs-6">' +
                                '<select id="' + RiskFactorSetupVM.AssessmentTypeList()[i].AssessmentId() + '" data-bind="foreach: { data: riskLevels, as: \'List1\' }" class="form-control">' +
                                '<!-- ko if: (List1.AssessmentTypeId == ' + RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[j] + ' || List1.AssessmentTypeId == 99999)-->' +
                                '<!-- ko if: !(List1.isQuantitative == 1)-->' +
                                '<optgroup data-bind="attr: {label: RiskLevelName}, foreach: MappedRiskLevels">' +
                                '<option data-bind="text: RiskLevelDescription, value: RiskLevelId"></option>' +
                                '</optgroup>' +
                                '<!--/ko -->' +
                                '<!--/ko -->' +
                                '</select>' +
                                '</div>' +
                                '</div>';
                        }
                    }
                }

                document.getElementById('DynamicScoreDiv').innerHTML = DynamicHTMl;
                ko.cleanNode(document.getElementById('DynamicScoreDiv'));
                ko.applyBindings(RiskFactorSetupVM, document.getElementById("DynamicScoreDiv"));
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForDropDowns() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function BindDynamicHtmlForDropDownsEdit(data) {

            try {
                var DynamicHTMl = "";
                var arr = [];

                for (var k = 0; k < data.length; k++) {
                    var splitID = data[k].split(',')


                    for (var g = 0; g < RiskFactorSetupVM.AssessmentTypeList().length; g++) {

                        if (parseInt(splitID[1]) == RiskFactorSetupVM.AssessmentTypeList()[g].AssessmentId()) {
                            DynamicHTMl +=
                                '<div class="form-group">' +
                                '<label class="col-xs-4 col-sm-4 col-md-4 col-lg-4 control-label">' + RiskFactorSetupVM.AssessmentTypeList()[g].AssessmentName() + ' Risk Level</label>' +
                                '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                                '<select id="' + RiskFactorSetupVM.AssessmentTypeList()[g].AssessmentId() + '"data-bind="foreach: { data: riskLevels, as: \'List1\' }" class="form-control">' +
                                '<!-- ko if: (List1.AssessmentTypeId ==' + splitID[1] + '|| List1.AssessmentTypeId == 99999)-->' +
                                '<!-- ko if: !(List1.isQuantitative ==1)-->' +
                                '<optgroup data-bind="attr: {label: RiskLevelName}, foreach: MappedRiskLevels">' +
                                '<option data-bind="text: RiskLevelDescription,value:RiskLevelId"></option>' +
                                '</optgroup>' +
                                '<!--/ko -->' +
                                '<!--/ko -->' +
                                '</select>' +
                                '</div>' +
                                '</div>';
                        }
                    }

                }


                document.getElementById('DynamicScoreDiv').innerHTML = DynamicHTMl;
                ko.cleanNode(document.getElementById('DynamicScoreDiv'));
                ko.applyBindings(RiskFactorSetupVM, document.getElementById("DynamicScoreDiv"));
                for (var k = 0; k < data.length; k++) {
                    var splitID = data[k].split(',')
                    $('#' + parseInt(splitID[1])).val(parseInt(splitID[0]))
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForDropDownsEdit() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }
        /**
         * Open Delete SubFactor Confirmation PopUP
         **/
        function onDeleteSubFactor(data, event) {
            try {
                app.showMessage('<b>Are you sure that you want to delete this Sub Factor (Response)?<br/><br/><b>', 'Delete Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                    .then(function (option) {
                        if (option === 'Confirm') {
                            deleteSubFactor(data);
                        }
                    });

                setTimeout(function () {
                    $(event.target).focus();
                }, 1);
                event.preventDefault();
                event.stopImmediatePropagation();
                event.stopPropagation();
                return false;
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: onDeleteSubFactor() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        /**
        *  Delete Factor
        **/
        function deleteSubFactor(data) {
            try {
                $.ajax({
                    url: "/api/productRiskFactors/subFactors/" + data.ID,
                    type: "DELETE",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in deleteSubFactor() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(result, status) {
                try {
                    getFactorsResponses({ ID: data.ParentFactorID }).then(function () {
                        createResponsesTable(RiskFactorSetupVM.SelectedResponseRow());
                    });
                    toastr.success("SubFactor has been deleted successfully!");
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteFactor() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 409) {
                        logger.logError('You are not able to delete this Response, because it is used somewhere in the application!', 'Error', system.getModuleId(RiskFactorSetupVM), true);

                    } else if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {
                                    navigation.unauthorized();
                                }
                            });
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in deleteSubFactor() method in RiskFactorSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteSubFactor() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            }
        }




        /* Response Type Methods START */
        function openResponseTypePopUp() {
            try {
                $('#responseTypeModal').modal('show');
                $('#modalContent').css({
                    'margin-top': '25%'
                });
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: openResponseTypePopUp() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function getAllResponseTypes() {
            try {
                $.ajax({
                    url: "/api/productRiskFactors/responseTypes",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, error) {
                        RiskFactorSetupVM.ResponseTypeList([]);

                        if (jsonResult) {
                            RiskFactorSetupVM.ResponseTypeList(jsonResult);
                            RiskFactorSetupVM.newResponseType('');
                        }
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    });

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllResponseTypes() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function cancelResponseTypePopUp() {
            try {
                //AMLQsViewModel.RiskAreaReorderList([]);
                //var MappedRiskAreaSortMOdelDup = $.map(AMLQsViewModel.RiskAreaReorderListDup(), function (result) {
                //    return new RiskAreaSortOrderDupModel(result);
                //});
                //AMLQsViewModel.RiskAreaReorderList(MappedRiskAreaSortMOdelDup)
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: cancelResponseTypePopUp() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function addResponseType() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                if (RiskFactorSetupVM.newResponseType() === '') {
                    $('#errorMessageRT').show();
                    $('#errorMessageRT').text('Response Type can not be empty!');
                    return false;
                }
                $('#errorMessageRT').hide();
                $('#errorMessageRT').text('');

                $.ajax({
                    url: "/api/productRiskFactors/responseTypes?newResponseTypeName=" + RiskFactorSetupVM.newResponseType(),
                    type: "POST",
                    //data: { Name: RiskFactorSetupVM.newResponseType() },
                    headers: headers
                })
                    .success(addResponseTypeSuccess)
                    .fail(addResponseTypeFail);

                function addResponseTypeSuccess(jsonResult, status) {
                    try {
                        if (jsonResult != null) {
                            RiskFactorSetupVM.ResponseTypeList(jsonResult);
                            RiskFactorSetupVM.newResponseType("");
                            getAllResponseTypes();
                            toastr.success("Response Type has been added successfully!");
                        } else {
                            logger.logError('An error occurred. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetup), true);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in addResponseType() method in RiskFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }

                function addResponseTypeFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addResponseType() method in RiskFactorSetup.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in addResponseType() method in RiskFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in addResponseType() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function updateResponseType(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/productRiskFactors/responseTypes ",
                    type: "PUT",
                    data: { ID: data.ID, Name: data.Name },
                    headers: headers
                })
                    .success(updateResponseTypeSuccess)
                    .fail(updateResponseTypeFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in updateResponseType() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }

            function updateResponseTypeSuccess(jsonResult, status) {
                try {
                    toastr.success("Response Type has been edited successfully!");
                    if (jsonResult != null) {
                        //getAllResponseTypes();
                    } else {
                        logger.logError('An error occurred. Please contact your Administrator.', 'Error', system.getModuleId(AMLQsViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in updateResponseItem() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function updateResponseTypeFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {
                                    navigation.unauthorized();
                                }
                            });
                    } else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in updateResponseType() method in RiskFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in updateResponseType() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function deleteResponseType(data, event) {
            try {
                app.showMessage('<b>Are you sure you want to delete this Response type?<br/><br/><b>', 'Delete Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                    .then(function (option) {
                        if (option === 'Confirm') {
                            deleteResponseItem(data);
                        }
                    });

                setTimeout(function () {
                    $(event.target).focus();
                }, 1);
                event.preventDefault();
                event.stopImmediatePropagation();
                event.stopPropagation();
                return false;
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: deleteResponseType() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function deleteResponseItem(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/productRiskFactors/responseTypes/" + data.ID,
                    type: "DELETE",
                    headers: headers,
                })
                    .success(deleteResponseSuccess)
                    .fail(deleteResponseFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in deleteResponseItem() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }

            function deleteResponseSuccess(jsonResult, status) {
                try {
                    toastr.success("Response Type has been deleted successfully!");
                    if (jsonResult == 2) {
                        logger.logError('The Response cannot be deleted as it is used in the Application.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    } else if (jsonResult != null) {
                        getAllResponseTypes();
                    } else {
                        logger.logError('An error occurred. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteResponseItem() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function deleteResponseFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Delete Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {
                                    navigation.unauthorized();
                                }
                            });
                    } else if (error.status == 409) {
                        //app.showMessage("You already use this Response Type and you cannot delete it!", "Error in Delete Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        //.then(function (option) {
                        //    if (option == "OK") {
                        //        navigation.unauthorized();
                        //    }
                        //});
                        logger.logError('The Response cannot be deleted as it is used in the Application.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteResponseItem() method in RiskFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteResponseItem() method in RiskFactorSetup.js';
                    logger.logMessage(msg);
                }
            }
        }
        /* Response Type Methods END */


        /**
         * Get language name by its ID
         **/
        function getLanguageName(languageId) {
            if (RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length == 0) {
                RiskFactorSetupVM.ObjGeneralSettings.getLanguages();
            }

            for (var i = 0; i < RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length; i++) {
                if (RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID().toString() === languageId.toString()) {
                    return RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME();
                }
            }

            return '';
        }

        /**
         *   Models
         **/
        function AssessmentListModel(item) {
            try {
                var self = this;
                self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
                self.AssessmentName = ko.observable(item.AssessmentName);
                self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
                self.Description = ko.observable($('<div/>').html(item.Description).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function FactorModel(factor) {
            var self = this;
            self.ID = factor.ID || null;
            self.Name = ko.observable(factor.Name || '');
            self.Type = ko.observable(factor.Type || ''),
                self.ResponseTypes = ko.observable(factor.ResponseTypes || '');
            self.AssessmentTypes = ko.observable(factor.AssessmentTypes || '');
            self.LanguageData = ko.observableArray(factor.LanguageData || []);
            // self.ParentQuestionID = ko.observable(factor.ParentQuestionID || null);
            // self.ParentResponsesID - ko.observableArray(factor.ParentResponsesID || '');

        }

        function FactorLanguageData(languageId, languageValue) {
            try {
                var self = this;
                self.LanguageID = languageId;
                self.LanguageData = languageValue || $('#factor' + languageId).val();
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: factorLanguageData() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        };

        function SubFactorLanguageData(languageId, languageValue) {
            try {
                var self = this;
                self.LanguageID = languageId;
                self.LanguageData = languageValue || $('#response' + languageId).val();
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubFactorLanguageData() method in RiskFactorSetup.js';
                logger.logMessage(msg);
            }
        };

        function SubFactorModel(SubFactor) {
            var self = this;
            self.ID = SubFactor.ID || null;
            self.ParentFactorID = SubFactor.ParentFactorID || null;
            self.Name = ko.observable(SubFactor.Name || '');
            self.ResponseTypes = ko.observable(SubFactor.ResponseTypes || '');
            self.AssessmentTypes = ko.observable(SubFactor.AssessmentTypes || '');
            self.Score = ko.observable(SubFactor.Score || '');
            self.LanguageData = ko.observableArray(SubFactor.LanguageData || []);
            self.SeqNum = ko.observable(SubFactor.SeqNum || 0);
        }

        function RiskLevelModel(item) {
            try {
                var self = this;
                self.RiskLevelId = item.RiskLevelId;
                self.RiskLevelName = item.RiskLevelName;
                self.RiskLevelShortText = item.RiskLevelShortText;
                self.ScoringType = item.ScoringType;
                self.LevelCount = item.RiskLevelCount;
                self.AssessmentTypeId = item.AssessmentId;
                self.isQuantitative = item.isQuantitative;
                self.MappedRiskLevels = $.map(item.RiskLevelDetailsModel, function (result) {
                    return new InherentRiskLevelModel(result);
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RiskLevelModel() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function InherentRiskLevelModel(item) {
            try {
                var self = this;
                self.RiskLevelId = item.RiskLevelId;
                self.RiskLevelParentId = item.RiskLevelParentId;
                self.RiskLevelcss = item.RiskLevelcss;
                self.RiskLevelComents = item.RiskLevelComents;
                self.RiskLevelDescription = item.RiskLevel + ' - ' + item.RiskLevelDescription;
                self.RiskLevel = item.RiskLevel;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: InherentRiskLevelModel() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }
    });

